import { Component } from '@angular/core'
import { IconButtonComponent, IconLegacyComponent, TooltipModule } from '@ftr/foundation'
import { featureFlag, LaunchDarklyModule } from '@ftr/ui-feature-flags'
import { LogoSize, LogoTheme } from '../../types'
import { FtrLogoComponent } from '../ftr-logo'
@Component({
  selector: 'ftr-header-logged-out',
  templateUrl: './header-logged-out.component.html',
  styleUrls: ['./header-logged-out.component.css'],
  imports: [FtrLogoComponent, TooltipModule, IconLegacyComponent, LaunchDarklyModule, IconButtonComponent],
})
export class HeaderLoggedOutComponent {
  readonly logoThemes = LogoTheme
  readonly logoSizes = LogoSize

  isPublicNavigationEnabled = featureFlag('public-navigation')

  openHelpAndSupport(): void {
    // NOOP
  }
}
